/**
 * Severity-override copy shared by the single-alert modal
 * (`AlertSeverityOverrideCell`) and the bulk modal (`bulkActionCopy`).
 */

/**
 * What an override reaches (KIR-5205: filters, sorting, search and the
 * dashboards follow it too). Keep it in step with the Alerts docs page.
 */
export const SEVERITY_OVERRIDE_REACH =
  'The updated severity will also apply to any future matching alerts and is used for notification preferences, endpoint alerts, filters, sorting and the dashboards.';
